import {
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  NgZone,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { DOCUMENT } from '@angular/common';
import { Observable } from 'rxjs';

import { HintsService } from './hints.service';
import { SegmentValidationService } from '../validation/segment-validation/segment-validation.service';
import {fromEvent} from 'rxjs/internal/observable/fromEvent';
import {takeWhile} from 'rxjs/operators';


@Directive({
  selector: '[hintsContainer]',
  exportAs: 'hints-container-directive'
})
export class HintsContainerDirective implements OnInit, OnDestroy {

  @Input() validation: boolean = false;

  private isHintContainerActive: boolean = true;

  constructor(
    private hintsService: HintsService,
    private validationService: SegmentValidationService,
    private _elementRef: ElementRef,
    private ngZone: NgZone,
    @Inject(DOCUMENT) private document: any,
  ) {}

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(this.document, 'click')
      .pipe(takeWhile(() => this.isHintContainerActive))
      .subscribe((event: MouseEvent) => {
        this.onDocumentClick(event);
      });
    });
  }

  ngOnDestroy() {
    this.isHintContainerActive = false;
    this.validationService.resetValidation();
  }

  onDocumentClick(event: MouseEvent) {
    const target = event.target;
    if (!(target instanceof HTMLElement)) {
      return;
    }
    let isHintField = !!target.className?.match('hint-item');
    if (!isHintField
        && target.parentNode
        && target.parentNode instanceof HTMLElement
        && target.parentNode.className) {
      isHintField = !!target.parentNode.className?.match('hint-item');
    }
    if (!this.hintsService.model.isHintDefault && !isHintField) {
      this.hintsService.resetHint();
      if (this.validation) { this.validationService.resetValidation(); }
    }
  }
}
